module.exports = __webpack_public_path__ + "static/img/13.0b1e364.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/13.png
// module id = JDpw
// module chunks = 0